(() => {
  if (customElements.get('zovqo-tabby-promo')) return;
  let sdk;
  let sequence = 0;
  const loadSdk = () => {
    if (window.TabbyPromo) return Promise.resolve();
    if (!sdk) {
      sdk = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://checkout.tabby.ai/tabby-promo.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.append(script);
      });
    }
    return sdk;
  };
  class TabbyPromoElement extends HTMLElement {
    static observedAttributes = ['data-price', 'data-currency', 'data-lang'];
    connectedCallback() {
      this.renderPromo();
    }
    attributeChangedCallback() {
      if (this.isConnected) this.renderPromo();
    }
    async renderPromo() {
      const revision = (this.revision || 0) + 1;
      this.revision = revision;
      try {
        await loadSdk();
        if (!this.isConnected || this.revision !== revision) return;
        const price = Number(this.dataset.price);
        if (!Number.isFinite(price) || price <= 0 || this.dataset.currency !== 'AED') {
          this.replaceChildren();
          return;
        }
        const target = document.createElement('div');
        target.id = `zovqo-tabby-${++sequence}`;
        this.replaceChildren(target);
        new window.TabbyPromo({
          selector: `#${target.id}`,
          currency: this.dataset.currency,
          price: price.toFixed(2),
          lang: this.dataset.lang === 'ar' ? 'ar' : 'en',
          source: this.dataset.source,
          publicKey: 'pk_01a168a1-99c9-8145-406b-56663f4b30d6',
          merchantCode: 'default'
        });
      } catch {
        this.replaceChildren();
      }
    }
  }
  customElements.define('zovqo-tabby-promo', TabbyPromoElement);
})();
